module.exports = __webpack_public_path__ + "img/stvrt-mapa-sever.156731fd.jpg";